module.exports = __webpack_public_path__ + "img/5.c448a3e9.jpg";